import React from 'react'
import { baseSales } from './base'
import { FormInterpreter } from '../../@core/components/interpreter/FormInterpreter'

export const SaleForm = () => {
    return (<FormInterpreter {...baseSales} />)
}